import { createStore } from 'vuex'
import main from './main'
import local from './local'
import sideMenu from './side-menu'
import simpleMenu from './simple-menu'
import topMenu from './top-menu'
// import localForage from 'localforage'

const store = createStore({
  modules: {
    main,
    local,
    sideMenu,
    simpleMenu,
    topMenu
  }
})

export function useStore() {
  return store
}

export default store
